import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Proteus admin module — `/proteus` on console.francisquini.ai.
 *
 * Surfaces the schema registry + user/org pref editor + audit log + a
 * link out to the existing `/cockpit/proteus/freshness` page (which
 * lives in the `cockpit` module and is untouched by this module).
 *
 * Surface is `'admin'` — registered only on the console host. The
 * `RequireAdmin` gate on each page enforces `is_super_admin` claim as
 * defence-in-depth on top of the host split.
 *
 * Spec: docs/cockpit/dashboards/tier-4-admin-baixa-frequencia.md §4.3.
 */
export const manifest: ModuleManifest = {
  module_id: 'proteus',
  display_name: 'Proteus',
  surface: 'admin',
  routes: [
    {
      path: '/proteus',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusHomePage,
        })),
      title: 'Proteus — Dashboard',
      permissions: [],
    },
    {
      path: '/proteus/schemas',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusSchemasPage,
        })),
      title: 'Proteus — Schemas',
      permissions: [],
    },
    {
      path: '/proteus/schemas/$key',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusSchemaDetailPage,
        })),
      title: 'Proteus — Schema detail',
      permissions: [],
    },
    {
      path: '/proteus/users/$userId',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusUserPrefsPage,
        })),
      title: 'Proteus — User prefs',
      permissions: [],
    },
    {
      path: '/proteus/orgs/$orgId',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusOrgPrefsPage,
        })),
      title: 'Proteus — Org prefs',
      permissions: [],
    },
    {
      path: '/proteus/audit',
      component: () =>
        import('@/routes/_app/proteus').then((m) => ({
          default: m.ProteusAuditPage,
        })),
      title: 'Proteus — Audit',
      permissions: [],
    },
  ],
}
